<template>
  <a class="skip-link" :href="target">跳到主要內容</a>
</template>

<script>
export default {
  name: "SkipLink",
  props: {
    target: {
      type: String,
      default: "#main-content",
    },
  },
};
</script>

<style scoped>
.skip-link {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  padding: 8px 12px;
  color: #fff;
  background: #000;
  transform: translateY(-120%);
}

.skip-link:focus {
  transform: translateY(0);
}
</style>
